const ORDER_STEPS = [
  {
    step: '01',
    icon: 'ri-message-2-line',
    title: 'Пишите в мессенджер',
    desc: 'Описываете задачу: какой тип качелей нужен, сколько&nbsp;мест, пожелания по&nbsp;дизайну и&nbsp;материалу.',
  },
  {
    step: '02',
    icon: 'ri-ruler-2-line',
    title: 'Согласовываем размеры',
    desc: 'Уточняем детали: габариты, тип&nbsp;сиденья, нужен&nbsp;ли навес, цвет по&nbsp;RAL. Подбираем оптимальную&nbsp;модель.',
  },
  {
    step: '03',
    icon: 'ri-file-list-2-line',
    title: 'Получаете расчёт и эскиз',
    desc: 'Готовим подробную смету и&nbsp;визуализацию. Все позиции расписаны&nbsp;—&nbsp;материал, работа, доставка, монтаж.',
  },
  {
    step: '04',
    icon: 'ri-check-double-line',
    title: 'Изготовление и монтаж',
    desc: 'После согласования запускаем в&nbsp;производство. Доставляем и&nbsp;устанавливаем под ключ за&nbsp;5–10&nbsp;дней.',
  },
];

const DEFAULT_MESSAGE = 'Здравствуйте! Хочу рассчитать стоимость садовых качелей.';
const whatsappDefaultUrl = `https://wa.me/79174131562?text=${encodeURIComponent(DEFAULT_MESSAGE)}`;
const telegramDefaultUrl = `https://t.me/share/url?url=&text=${encodeURIComponent(DEFAULT_MESSAGE)}`;

export default function OrderSection() {
  return (
    <>
      {/* How to order */}
      <section className="py-16 md:py-20 bg-background-50">
        <div className="mx-auto px-4 md:px-6" style={{ maxWidth: '1400px' }}>
          <div className="text-center mb-12 md:mb-16">
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">Как заказать</h2>
            <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
              Четыре простых шага — от&nbsp;сообщения до&nbsp;готовых качелей на&nbsp;вашем&nbsp;участке
            </p>
          </div>

          <div className="relative">
            <div className="hidden lg:block absolute top-14 left-[8%] right-[8%] h-[2px] bg-background-300"></div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
              {ORDER_STEPS.map((step) => (
                <div key={step.step} className="relative text-center group animate-fade-in-up">
                  <div className="relative z-10 mx-auto w-14 h-14 flex items-center justify-center rounded-full bg-background-50 border-2 border-background-200 text-foreground-950 group-hover:bg-primary-500 group-hover:border-primary-500 group-hover:text-background-50 transition-all duration-400 mb-5">
                    <span className="font-heading text-base font-bold">{step.step}</span>
                  </div>
                  <div className="w-10 h-10 mx-auto flex items-center justify-center text-primary-500 mb-3">
                    <i className={`${step.icon} text-2xl`}></i>
                  </div>
                  <h3 className="font-heading text-base font-semibold text-foreground-950 mb-2">{step.title}</h3>
                  <p className="text-sm text-foreground-600 leading-relaxed" dangerouslySetInnerHTML={{ __html: step.desc }}></p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Messenger CTA */}
      <section className="py-16 md:py-20 bg-background-100" id="messenger-calc">
        <div className="mx-auto px-4 md:px-6" style={{ maxWidth: '800px' }}>
          <div className="bg-background-50 border border-background-200/70 rounded-lg p-7 md:p-10 text-center">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
              Рассчитайте стоимость в мессенджере
            </h2>
            <p className="text-sm md:text-base text-foreground-600 max-w-md mx-auto mb-8">
              Напишите в удобный мессенджер — согласуем размеры и&nbsp;подготовим расчёт в&nbsp;течение дня
            </p>

            <div className="flex flex-wrap items-center justify-center gap-3">
              <a
                href={whatsappDefaultUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="whitespace-nowrap inline-flex items-center gap-2.5 bg-[#25D366] hover:bg-[#1eb851] text-background-50 font-medium text-sm px-6 py-3 rounded-md transition-all duration-300 cursor-pointer hover:scale-105"
              >
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-whatsapp-line text-lg"></i>
                </span>
                WhatsApp
              </a>
              <a
                href="https://max.ru/u/f9LHodD0cOICoHyOC2LT2Vx_42oC8Zdm2VV9Uv5O-6mGvkZgeZzUcJQkER0"
                target="_blank"
                rel="noopener noreferrer"
                className="whitespace-nowrap inline-flex items-center gap-2.5 bg-accent-600 hover:bg-accent-700 text-background-50 font-medium text-sm px-6 py-3 rounded-md transition-all duration-300 cursor-pointer hover:scale-105"
              >
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-chat-3-line text-lg"></i>
                </span>
                MAX
              </a>
              <a
                href={telegramDefaultUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="whitespace-nowrap inline-flex items-center gap-2.5 bg-[#2AABEE] hover:bg-[#2299d6] text-background-50 font-medium text-sm px-6 py-3 rounded-md transition-all duration-300 cursor-pointer hover:scale-105"
              >
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-telegram-line text-lg"></i>
                </span>
                Telegram
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="relative py-20 md:py-24 overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Beautiful%20garden%20swing%20with%20dark%20metal%20frame%20and%20wooden%20seat%20soft%20cushions%20on%20a%20green%20lawn%20in%20a%20blooming%20garden%20warm%20golden%20hour%20sunset%20light%20cozy%20peaceful%20outdoor%20living%20atmosphere%20flowers%20and%20greenery%20realistic%20professional%20photography%20high%20quality%20wide%20angle%20shot&width=1800&height=900&seq=swings-final-cta&orientation=landscape"
            alt=""
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/45 to-black/65"></div>
        </div>

        <div className="relative z-10 text-center px-4 md:px-6">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-background-50 mb-4">
            Обсудим ваш проект?
          </h2>
          <p className="text-sm md:text-base text-background-50/80 max-w-xl mx-auto mb-8 leading-relaxed">
            Отправьте фото, размеры или пример понравившегося изделия. Подскажем оптимальное решение и&nbsp;подготовим ориентировочный расчёт в&nbsp;течение дня.
          </p>

          <div className="flex flex-wrap items-center justify-center gap-3">
            <a
              href="https://wa.me/79174131562"
              target="_blank"
              rel="noopener noreferrer"
              className="whitespace-nowrap inline-flex items-center gap-2.5 bg-[#25D366] hover:bg-[#1eb851] text-background-50 font-semibold text-sm px-7 py-3.5 rounded-md transition-all duration-300 cursor-pointer hover:scale-105"
            >
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-whatsapp-line text-lg"></i>
              </span>
              WhatsApp
            </a>
            <a
              href="https://max.ru/u/f9LHodD0cOICoHyOC2LT2Vx_42oC8Zdm2VV9Uv5O-6mGvkZgeZzUcJQkER0"
              target="_blank"
              rel="noopener noreferrer"
              className="whitespace-nowrap inline-flex items-center gap-2.5 bg-accent-600 hover:bg-accent-700 text-background-50 font-medium text-sm px-6 py-3 rounded-md transition-all duration-300 cursor-pointer hover:scale-105"
            >
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-chat-3-line text-lg"></i>
              </span>
              MAX
            </a>
            <a
              href="https://t.me/share/url?url=&text=%D0%97%D0%B4%D1%80%D0%B0%D0%B2%D1%81%D1%82%D0%B2%D1%83%D0%B9%D1%82%D0%B5!%20%D0%A5%D0%BE%D1%87%D1%83%20%D1%80%D0%B0%D1%81%D1%81%D1%87%D0%B8%D1%82%D0%B0%D1%82%D1%8C%20%D1%81%D1%82%D0%BE%D0%B8%D0%BC%D0%BE%D1%81%D1%82%D1%8C%20%D1%81%D0%B0%D0%B4%D0%BE%D0%B2%D1%8B%D1%85%20%D0%BA%D0%B0%D1%87%D0%B5%D0%BB%D0%B5%D0%B9."
              target="_blank"
              rel="noopener noreferrer"
              className="whitespace-nowrap inline-flex items-center gap-2.5 bg-[#2AABEE] hover:bg-[#2299d6] text-background-50 font-medium text-sm px-6 py-3 rounded-md transition-all duration-300 cursor-pointer hover:scale-105"
            >
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-telegram-line text-lg"></i>
              </span>
              Telegram
            </a>
            <a
              href="tel:+79174131562"
              className="whitespace-nowrap inline-flex items-center gap-2.5 border-2 border-background-50/40 hover:border-background-50 text-background-50 font-medium text-sm px-6 py-3 rounded-md transition-all duration-300 cursor-pointer hover:bg-background-50/10"
            >
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-phone-fill text-lg"></i>
              </span>
              Позвонить
            </a>
          </div>
        </div>
      </section>
    </>
  );
}